import { MetaRoot } from 'util/metaPath'

import { createCpfCnsCalculation, createDescricaoCalculation } from '../calculator-atestadoCommon'
import AtestadoModel, { CidadaoAtestado } from '../components/model-atestado'
import { getLicencaMaternidadeText } from './utils-licencaMaternidade'

export const createLicencaMaternidadeCalculations = (
  path: MetaRoot<AtestadoModel>,
  cidadao: CidadaoAtestado,
  dataAtendimento: LocalDate
) => [
  createCpfCnsCalculation(path),
  createDescricaoCalculation(path, [path.cpfCns.absolutePath(), path.naoPossui.absolutePath()], (values) =>
    getLicencaMaternidadeText(cidadao, values.cpfCns, values.naoPossui, dataAtendimento)
  ),
]
